module.exports = __webpack_public_path__ + "static/img/icon4.0c30d7df.png";